import React from "react";
import "../../../assets/css/app.css";
import "./Services.css";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

import serv1 from "../../../assets/imgs/services/serv1.png";
import serv2 from "../../../assets/imgs/services/serv2.png";
import serv3 from "../../../assets/imgs/services/serv3.png";
import serv4 from "../../../assets/imgs/services/serv4.png";

function Services({ open, openContactForm }) {
  const navigate = useNavigate();


  const handleContact = () => {
    if (typeof openContactForm === "function") {
      openContactForm();
    } else {
      navigate("/contact");
    }
  };

  const servicesData = [
    {
      title: "Payment Strategy & Advisory",
      subtitle: "Precision Payments. Strategic Impact.",
      desc: "We partner with you to craft payment strategies that work. Our approach begins with a deep understanding of your business model, operational challenges, and growth aspirations. We then design and recommend secure, reliable, and cost-effective payment solutions.",
      img: serv1,
      reverse: false,
      link: "/payment-strategy-and-advisory",
    },
    {
      title: "Tech & Cloud Solutions",
      subtitle: "From Simple Builds to Enterprise Excellence.",
      desc: "We deliver technology and cloud solutions that scale with your vision. From a simple, high-impact website to complex ERP, CRM, and cloud-based architectures, our solutions are designed for performance, security, and long-term adaptability.",
      img: serv2,
      reverse: true,
      link: "/tech-and-cloud-solution",
    },
    {
      title: "Business Consultancy",
      subtitle: "Insights That Drive Impact.",
      desc: "At Paytech Advisors, we don’t just advise — we transform businesses. Our consultancy approach blends market intelligence, operational expertise, and growth-driven strategies to help you navigate challenges and seize opportunities with confidence.",
      img: serv3,
      reverse: false,
      link: "/business-consultancy",
    },
    {
      title: "360° Marketing",
      subtitle: "Your Brand, Everywhere That Matters.",
      desc: "We deliver marketing strategies that connect your brand with the right audience, at the right time, across every touchpoint. Our 360° approach integrates digital, social, offline, and experiential marketing to create a cohesive, impactful brand presence.",
      img: serv4,
      reverse: true,
      link: "/marketing",
    },
  ];

  return (
    <section className="servMn">
      <div className="maxW">
        {servicesData.map((service, index) => (
          <div className="serCard" key={index+1}>
            {!service.reverse ? (
              <>
                <div className="serWlft srLmgWrp">
                  <img src={service.img} alt={`serv${index + 1}-img`} />
                </div>
                <div className="serWryt">
                  <h2>{service.title}</h2>
                  <h3 className="serSub">{service.subtitle}</h3>
                  <p>{service.desc}</p>
                  <div className="webBtns">
                    <Button
                      variant="contained"
                      component={Link}
                      to={service.link}
                      className="btnLink"
                    >
                      Explore More
                    </Button>

                 
                    <Button variant="contained" onClick={handleContact}>
                      Get In Touch
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="serWlft">
                  <h2>{service.title}</h2>
                  <h3 className="serSub">{service.subtitle}</h3>
                  <p>{service.desc}</p>
                  <div className="webBtns">
                    <Button
                      variant="contained"
                      component={Link}
                      to={service.link}
                      className="btnLink"
                    >
                      Explore More
                    </Button>
                    <Button variant="contained" onClick={handleContact}>
                      Get In Touch
                    </Button>
                  </div>
                </div>
                <div className="serWryt srRmgWrp">
                  <img src={service.img} alt={`serv${index + 1}-img`} />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
Services.propTypes = {
  open: PropTypes.bool,
  openContactForm: PropTypes.bool, 
};

Services.defaultProps = {
  open: false,
  openContactForm: false, 
};

export default Services;
